import {List, Record} from 'immutable';

export interface MenuItem {
    id: string;
    title: string;
    link?: string;
    subtitle?: string;
    icon: MenuIcon;
    type: MenuItemType;
    items: List<MenuItem>;
}

export type MenuIcon =
    | 'newsfeed'
    | 'calendar'
    | 'apps'
    | 'billPayers'
    | 'settings'
    | 'childDevelopment'
    | 'activityLibrary'
    | 'more'
    | 'messages'
    | 'notifications'
    | 'logout'
    | 'collapsed'
    | 'default'
    | 'helpAndSupport'
    | 'INTERCOM'
    | 'GETTING_STARTED'
    | 'WHATS_NEW'
    | 'HELP_CENTER'
    | 'COMMUNITY'
    | 'lessonPlans'
    | 'home'
    | 'revenue'
    | 'occupancy'
    | 'billingActivity'
    | 'famlyInsights'
    | 'balanceReport'
    | 'publicFundingReport'
    | 'SettingsPage'
    | 'FamlyStore'
    | 'Account';

export type MenuItemType =
    | 'newsfeed'
    | 'calendar'
    | 'Famly.Daycare:Institution'
    | 'Famly.Daycare:Child'
    | 'Famly.Daycare:Organization'
    | 'Famly.Daycare:BillPayer'
    | 'billPayers'
    | 'apps'
    | 'freePackageApps'
    | 'settings'
    | 'more'
    | 'messages'
    | 'notifications'
    | 'logOut'
    | 'collapsed'
    | 'default'
    | 'common'
    | 'helpAndSupport'
    | 'lessonPlans'
    | 'OrganizationSettings'
    | 'OrganizationBillingActivity'
    | 'OrganizationRevenueReport'
    | 'OrganizationOccupancyReport'
    | 'OrganizationPublicFundingReport'
    | 'OrganizationBalanceReport'
    | 'OrganizationInsights'
    | 'SettingsPage'
    | 'FamlyStore';

export class MenuItemRecord extends Record<MenuItem>({
    id: '',
    title: '',
    link: '',
    subtitle: '',
    icon: 'default',
    type: 'default',
    items: List(),
}) {}
